export const AI_FEATURE_PROPERTY_KEYS = {
  ENABLE_AI_CHAT: 'EnableAiChat',
  ENABLE_AI_EXPRESSION_EXPLANATIONS: 'EnableAiExpressionExplanations',
  ENABLE_AI_EXPRESSION_GENERATIONS: 'EnableAiExpressionGenerations',
};
